/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Never_UsedInputs */

const en_settings_apikeys_never_used = /** @type {(inputs: Settings_Apikeys_Never_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never`)
};

const zh_settings_apikeys_never_used = /** @type {(inputs: Settings_Apikeys_Never_UsedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从未使用`)
};

/**
* | output |
* | --- |
* | "Never" |
*
* @param {Settings_Apikeys_Never_UsedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_never_used = /** @type {((inputs?: Settings_Apikeys_Never_UsedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Never_UsedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_never_used(inputs)
	return zh_settings_apikeys_never_used(inputs)
});
export { settings_apikeys_never_used as "settings.apikeys.never_used" }